<template>
  <layout-default :hide-footer-mobile="true" :show-alternative-header="true">
    <steps-header-recomend :current-step="2"></steps-header-recomend>

    <div class="recomendador2">
      <div class="pdv-container">
        <div class="title-content custom-padding">
          <h2 class="title">Selecciona bajo qué modalidad quieres estudiar</h2>
        </div>
        <div class="contenido-tabla custom-padding"></div>
      </div>
    </div>

    <div class="step-2-content">
      <div class="pdv-container">
        <div class="custom-padding">
          <div class="row no-gutters table-header-rows-container">
            <div
              :class="`${
                firstRow.length === 3 ? 'col-md-3' : 'col-md-3'
              } table-header main-name`"
              style="border-radius: 4px 0 0 0"
            >
              <!-- <span>Programas {{ getProgramName(courseClicked) }}</span> -->
            </div>
            <template v-for="(header, i) in firstRow">
              <div
                :class="`${
                  firstRow.length === 1
                    ? 'col-md-9'
                    : firstRow.length === 2
                    ? 'col'
                    : firstRow.length === 3
                    ? 'col'
                    : firstRow.length > 2
                    ? 'col'
                    : 'col'
                } table-header relative`"
                :style="{
                  borderRadius: firstRow.length - 1 === i ? '0 4px 0 0' : '',
                  background: '#FFF0F0',
                }"
                :key="i + header.name"
                v-if="isEsencial(header.name)"
              >
                <div class="border-ecesnsial">
                  <div class="border1"></div>
                </div>
                <div class="flex-center">
                  <div class="first-line">
                    <!--img :src="getIcon(header.name)" alt=""-->
                    <span class="header-name">{{
                      transformMetaNames(header.name, header.applyTo)
                    }}</span>
                  </div>
                  <span
                    class="header-sub-name"
                    v-if="header.shortName || header.shortName !== ''"
                    >{{ header.shortName }}</span
                  >
                </div>
              </div>
              <div
                :class="`${
                  firstRow.length === 1
                    ? 'col-md-9'
                    : firstRow.length === 2
                    ? 'col'
                    : firstRow.length === 3
                    ? 'col'
                    : firstRow.length > 2
                    ? 'col'
                    : 'col'
                } table-header`"
                :style="{
                  borderLeft: '6px solid #AE4239',
                  borderRadius: firstRow.length - 1 === i ? '0 4px 0 0' : '',
                  background: '#FFF0F0',
                }"
                :key="i"
                v-else
              >
                <div class="flex-center">
                  <div class="first-line">
                    <!--img :src="getIcon(header.name)" alt=""-->
                    <span class="header-name">{{
                      transformMetaNames(header.name, header.applyTo)
                    }}</span>
                  </div>
                  <span
                    class="header-sub-name"
                    v-if="header.shortName || header.shortName !== ''"
                    >{{ header.shortName }}</span
                  >
                </div>
              </div>
            </template>
          </div>
          <div
            class="row no-gutters table-body"
            :class="{ resaltada: row.name.toLowerCase().includes('precio') }"
            v-for="row in getBodyRows"
            :key="row.name"
          >
            <div
              :class="`${
                row.cols.length === 3 ? 'col-md-3' : 'col-md-3'
              } main-table-row`"
            >
              <span>{{ row.name }}</span>
              <img
                src="/images/featured/info-circle.svg"
                style="margin-left: 10px"
                alt="info"
                id="tooltip"
                v-tooltip="{
                  content: row.tooltip,
                  placement: 'right',
                  classes: ['value'],
                }"
              />
            </div>
            <div
              :class="`${
                row.cols.length === 1
                  ? 'col-md-9'
                  : row.cols.length === 2
                  ? 'col'
                  : row.cols.length === 3
                  ? 'col'
                  : row.cols.length > 2
                  ? 'col'
                  : 'col'
              } main-table-value`"
              v-for="(col, l) in row.cols"
              :key="l + col.name"
            >
              <img
                v-if="col.value.toLowerCase() === 'si'"
                src="/images/featured/tick-circle.svg"
              />
              <img
                v-else-if="col.value.toLowerCase() === 'no'"
                src="/images/featured/close-circle.svg"
              />
              <span
                v-else
                :style="[
                  row.name.toLowerCase().includes('precio')
                    ? { fontSize: '19px' }
                    : '',
                ]"
                >{{ col.value }}</span
              >
            </div>
          </div>
          <div class="row no-gutters table-body">
            <div
              :class="`${
                firstRow.length === 3 ? 'col-md-3' : 'col-md-3'
              } main-table-row last`"
              :style="{ borderRadius: '0 0 0 4px' }"
            ></div>
            <div
              :class="`${
                firstRow.length === 2
                  ? 'col'
                  : firstRow.length === 3
                  ? 'col'
                  : firstRow.length > 2
                  ? 'col'
                  : 'col-md-9'
              } main-table-value last`"
              v-for="(button, i) in firstRow"
              :key="i + i"
              :style="{
                borderRadius: firstRow.length - 1 === i ? '0 0 4px 0' : '',
              }"
            >
              <!--button class="black-button" @click="nextStep(button.name)" >
                Seleccionar
              </button-->
              <Button
                class="w-full"
                title="Seleccionar"
                type="primario"
                size="medium"
                @onClick="nextStep(button.name)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="firstRow" class="step2-mobile d-lg-none d-block">
      <div class="pdv-container custom-padding">
        <div class="form-group flex flex-col">
          <label for="program-select" class="mb-1"
            >Selecciona una modalidad</label
          >
          <div class="select-wrapper">
            <select
              class="input-select-program"
              id="program-select"
              v-model="selectedProgramIndex"
            >
              <option v-for="(row, i) in programData" :key="i" :value="i">
                {{ transformMetaNames(row.Metas.name, row.Metas.applyTo) }}
              </option>
            </select>
          </div>
        </div>

        <!-- <nav class="tabbable">
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <template v-for="(row, i) in programData">
              <a
                :key="i + row.Metas.name"
                v-if="isEsencial(row.Metas.name)"
                class="relative"
                :class="i == 0 ? 'nav-link active' : 'nav-link'"
                id="home-tab"
                data-toggle="tab"
                :href="'#tabsection' + i"
                role="tab"
                aria-controls="home"
                aria-selected="true"
              >
                <div class="border-ecesnsial">
                  <div class="border1"></div>
                  <div class="border2"></div>
                </div>
                <div class="row no-gutters">
                  <div class="col-12">
                    <div class="flex-center">
                      <div class="mobile-first-line">
                      
                        <span class="header-name">{{ row.Metas.name }}</span>
                        <img
                          src="/images/features/info-circle.svg"
                          alt=""
                          v-tooltip.right="''"
                        />
                      </div>
                      <span
                        class="header-sub-name"
                        v-if="row.Metas.shortName || row.Metas.shortName !== ''"
                        >{{ row.Metas.shortName }}</span
                      >
                    </div>
                  </div>
                </div>
              </a>
              <a
                v-else
                :key="i"
                :class="i % 2 == 0 ? 'par nav-link' : 'impar nav-link'"
                id="home-tab"
                data-toggle="tab"
                :href="'#tabsection' + i"
                role="tab"
                aria-controls="home"
                aria-selected="true"
                :style="{
                  borderLeft: ' solid 4px #AE4239',
                }"
              >
                <div class="row no-gutters">
                  <div class="col-12">
                    <div class="flex-center">
                      <div class="mobile-first-line">
                       
                        <span class="header-name">{{ row.Metas.name }}</span>
                        <img
                          src="/images/features/info-circle.svg"
                          alt=""
                          v-tooltip.right="''"
                        />
                      </div>
                      <span
                        class="header-sub-name"
                        v-if="row.Metas.shortName || row.Metas.shortName !== ''"
                        >{{ row.Metas.shortName }}</span
                      >
                    </div>
                  </div>
                </div>
              </a>
            </template>
          </div>
        </nav> -->
        <div class="tab-content" id="myTabContent">
          <div
            v-for="(row, i) in programData"
            :key="'det' + i + row.Metas.name"
            :class="
              i == selectedProgramIndex
                ? 'tab-pane fade show active'
                : 'tab-pane fade'
            "
            :id="'tabsection' + i"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div class="container no-padding relative">
              <div class="row no-gutters">
                <div
                  class="col-12 main-mobile-element"
                  v-for="main in getMainMobileRows(row.Details)"
                  :key="main.id"
                >
                  <div class="main-element-row-container">
                    <span class="main-mobile-element-row">{{ main.name }}</span>
                    <img
                      src="/images/featured/info-circle.svg"
                      alt=""
                      v-tooltip.right="main.tooltip"
                    />
                  </div>
                  <div class="main-element-row-container-value">
                    <img
                      v-if="main.ProgramDetail.value.toLowerCase() == 'si'"
                      src="/images/featured/tick-circle.svg"
                    />
                    <img
                      v-else-if="main.ProgramDetail.value.toLowerCase() == 'no'"
                      src="/images/featured/close-circle.svg"
                    />
                    <span v-else class="main-mobile-element-value">{{
                      main.ProgramDetail.value
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row no-gutters price-container">
                <div class="col-12 price-multiplier no-padding">
                  <div class="key">
                    <span>{{ getPricesRow(row.Details, "name") }}</span>
                  </div>
                  <div class="value">
                    <span>{{ getPricesRow(row.Details, "value") }}</span>
                  </div>
                </div>
              </div>
              <div class="row no-gutters button-see-more">
                <div class="col-12 center">
                  <Button
                    title="Seleccionar"
                    type="primario"
                    size="medium"
                    @onClick="nextStep(row.Metas.name)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pdv-container">
      <div class="custom-padding">
        <div class="p-0 mb-5 mt-5">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="common-text-section no-padding-mobile">
                <h5 class="title-commons">
                  {{
                    firstRow.length == 1
                      ? "Este Modelo Educativo Preu PDV 360° incluye"
                      : "Nuestro Modelo Educativo Preu PDV 360° incluye"
                  }}
                </h5>
                <div class="row list-commons">
                  <div
                    v-for="(row, i) in getCommonElements"
                    :key="row.name"
                    class="item-commons col-lg-3 col-md-6 col-sm-12 d-flex flex-column mt-4"
                  >
                    <div class="bullet" :class="getClassByIndex(i)">
                      <h5>{{ row.name }}</h5>
                    </div>
                    <div
                      class="my-2"
                      v-for="detail in row.details"
                      :key="detail.name"
                    >
                      <div>
                        <img
                          src="/images/featured/tick-circle-black.svg"
                          style="margin-right: 10px"
                          alt="tick-circle-black"
                        />
                        <span>{{ detail.name }}</span>
                        <img
                          src="/images/featured/info-circle.svg"
                          style="margin-left: 10px"
                          alt="info"
                          id="tooltip"
                          v-tooltip="{
                            content: detail.tooltip,
                            placement: 'right',
                            classes: ['value'],
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info-recomendador1">
      <img
        src="/images/featured/tri-sup-izq-gris-mobile.svg"
        class="only-mobile w-full"
        alt="tri-sup-izq-gris-mobile"
      />
      <img
        src="/images/featured/tri-sup-izq-gris-desktop.svg"
        class="only-desktop w-full"
        alt="tri-sup-izq-gris-desktop"
      />
      <div class="fondo">
        <div class="pdv-container">
          <div class="perent-columns">
            <div class="column-info">
              <h2 class="titulo">Si quieres saber más</h2>
              <div class="links">
                <a
                  href="/documents/fichas-academicas.pdf"
                  target="_blank"
                  class="links-items"
                >
                  <div class="links-items-text">
                    <img src="/images/featured/link.svg" class="" alt="link" />
                    <span>Conoce todos los programas</span>
                  </div>
                  <img
                    src="/images/featured/arrow-right.svg"
                    class=""
                    alt="arrow-right"
                  />
                </a>

                <a
                  href="/documents/fichas-academicas.pdf"
                  target="_blank"
                  class="links-items"
                >
                  <div class="links-items-text">
                    <img src="/images/featured/link.svg" class="" alt="link" />
                    <span>Modelo Educativo Preu PDV 360°</span>
                  </div>
                  <img
                    src="/images/featured/arrow-right.svg"
                    class=""
                    alt="arrow-right"
                  />
                </a>
              </div>
              <h3 class="texto only-desktop">
                ¿Tienes dudas sobre nuestros programas? Hablemos
              </h3>
              <div class="botones only-desktop">
                <a
                  href="tel:6005002020"
                  class="boton-new-primario boton-new-mediano"
                >
                  <img
                    src="/images/featured/call-icon.svg"
                    class=""
                    alt="callicon"
                  />
                  +56 2 2994 9850
                </a>
                <a
                  href="https://www.preupdv.cl/ayuda"
                  target="_blank"
                  class="boton-new-terciario boton-new-mediano"
                >
                  Preguntas frecuentes
                </a>
                <a
                  href="https://www.preupdv.cl/contacto"
                  target="_blank"
                  class="boton-new-terciario boton-new-mediano"
                >
                  Formulario de contacto
                </a>
              </div>
            </div>
            <div class="column-ilustracion">
              <img
                src="/images/featured/boy-computer-list-cap-design-verde.svg"
                class="w-full"
                alt="boy-bored-computer-coffee"
              />
            </div>

            <div class="only-mobile column-info">
              <h3 class="texto">
                ¿Tienes dudas sobre nuestros programas? Hablemos
              </h3>
              <div class="botones">
                <router-link
                  :to="{ name: 'Landing' }"
                  class="boton-new-primario boton-new-mediano"
                >
                  <img
                    src="/images/featured/call-icon.svg"
                    class=""
                    alt="callicon"
                  />
                  +56 2 2994 9850
                </router-link>
                <Button
                  title="Preguntas frecuentes"
                  type="terciario"
                  size="medium"
                  :fullWidth="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-if="loading" />
  </layout-default>
</template>

<script>
import LayoutDefault from "@/layouts/Default";
import StepsHeaderRecomend from "@/components/StepsHeaderRecomend";
import Loader from "@/components/Loader";
import Button from "@/components/featured/Button";

export default {
  components: {
    LayoutDefault,
    StepsHeaderRecomend,
    Button,
    Loader,
  },

  data() {
    return {
      loading: false,
      courseClicked: "",
      firstRow: [],
      yearSelected: "",
      programData: [],
      selectedProgramIndex: 0,
      isShowMore: false,
      setPosition: false,
    };
  },

  mounted() {
    if (localStorage.getItem("students")) {
      localStorage.removeItem("students");
      this.$router.push("/");
    }
    this.courseClicked = this.$route.params.course;
    window.addEventListener("scroll", this.scrollHandler);
    this.programData = this.$store.state.programData;
    this.programData.forEach((e) => {
      let programData = { ...e.Metas };
      this.firstRow.push(programData);
    });
  },
  computed: {
    getBodyRows() {
      let data = this.$store.state.programData;
      let mainBody = [];
      data.forEach((e) => {
        let filtered = e.Details.filter((el) => el.main);
        filtered.forEach((f) => {
          let objDetail = {
            name: f.name,
            tooltip: f.tooltip,
            cols: [{ name: e.name, value: f.ProgramDetail.value }],
          };
          let isPushed = mainBody.find((value) => value.name == f.name);
          if (isPushed) {
            let anotherCol = { name: e.name, value: f.ProgramDetail.value };
            isPushed.cols.push(anotherCol);
          } else {
            mainBody.push(objDetail);
          }
        });
      });
      return mainBody;
    },
    getCommonElements() {
      let data = this.$store.state.programData;

      let mainBody;
      data.forEach((e) => {
        let filtered = e.Details.filter((el) => !el.main);

        const groupedData = filtered.reduce(
          (acc, item) => {
            const categoryName = item.detailCategory.name;
            const detailObject = {
              name: item.name,
              tooltip: item.tooltip,
            };

            // Busca si la categoría ya existe en el acumulador
            let category = acc.detailCategories.find(
              (c) => c.name === categoryName
            );

            if (!category) {
              // Si no existe, la crea
              category = { name: categoryName, details: [] };
              acc.detailCategories.push(category);
            }

            // Agrega el nombre del detalle a la categoría correspondiente
            category.details.push(detailObject);

            return acc;
          },
          { detailCategories: [] }
        );

        mainBody = groupedData.detailCategories;
      });

      return mainBody;
    },
    getFormatProgramName() {
      return this.$store.state.formatProgramName;
    },
  },
  methods: {
    transformMetaNames(string, yearSelected) {
      if (yearSelected == 3) {
        return string
          .replace("SubeNotas Presencial", "Presencial")
          .replace("SubeNotas Streaming", "Streaming");
      }

      return string;
    },
    getClassByIndex(index) {
      const classes = [
        "pdv360bulletBgColor1",
        "pdv360bulletBgColor2",
        "pdv360bulletBgColor3",
        "pdv360bulletBgColor4",
      ];
      return classes[index % classes.length]; // Devuelve la clase según el índice
    },
    getFormatName(name) {
      if (!name) {
        return "";
      }
      name = name.toLowerCase();
      if (name === "sube notas pt") {
        return "Tradicional";
      } else if (name.includes("tradicional")) {
        return "Tradicional";
      } else if (name.includes("pdvx")) {
        return "PDVX";
      } else if (
        name.includes("grupo de estudio") ||
        name.includes("grupos de estudio")
      ) {
        return "Grupo Estudio";
      } else if (name.includes("pdv online") || name.includes("online")) {
        return "Online";
      } else if (name.includes("mentoring")) {
        return "Mentoring";
      } else {
        return "Esencial";
      }
    },
    getProgramName(data) {
      switch (data) {
        case "4":
          return "4° medio";
        case "3":
          return "3° medio";
        case "2":
          return "2° medio";
        case "1":
          return "1° medio";
        case "e":
          return "Egresados";
        case "E":
          return "Egresados";
        default:
          return data;
      }
    },
    getCommonRows(arr) {
      return arr.filter(
        (e) => !e.main && !e.name.toLowerCase().includes("precio")
      );
    },
    getMainMobileRows(arr) {
      return arr.filter((e) => e.main);
    },
    getPricesRow(arr, itemToGet) {
      if (
        arr.some((e) => e.name.toLowerCase().includes("precio")) &&
        itemToGet === "name"
      ) {
        return arr.find((e) => e.name.toLowerCase().includes("precio")).name;
      } else if (
        arr.some((e) => e.name.toLowerCase().includes("precio")) &&
        itemToGet === "value"
      ) {
        return arr.find((e) => e.name.toLowerCase().includes("precio"))
          .ProgramDetail.value;
      } else {
        return "";
      }
    },
    scrollHandler() {
      let heightScreen = document.getElementById("app").clientHeight;
      if (window.scrollY > heightScreen / 4) {
        this.setPosition = true;
      } else {
        this.setPosition = false;
      }
    },
    setShowMore() {
      this.isShowMore = !this.isShowMore;
    },
    sizeColumn(columns) {
      return "col";
    },
    getIcon(e) {
      if (!e) {
        return "";
      }
      e = e.toLowerCase();
      if (e == "tradicional") {
        return "/images/svgs/tradicional.svg";
      } else if (e == "pdvx") {
        return "/images/svgs/pdvx.svg";
      } else if (e == "pdv online") {
        return "/images/svgs/pdv-online.svg";
      } else if (e == "mentoring") {
        return "/images/svgs/mentoring.svg";
      } else {
        return "";
      }
    },
    async nextStep(name) {
      this.loading = true;

      const formatName = this.getFormatProgramName;
      let item = this.programData[this.selectedProgramIndex];
      //let item = this.programData.find((e) => e.Metas.name === name);

      const { data } = await this.Axios.get(
        `/programs/meta/${name}?year=${item.Metas.applyTo || ""}`
      );

      if (data[0].Childrens.length > 0) {
        this.$store.dispatch("setFormatProgramName", {
          ...formatName,
          nivel2: this.getFormatName(name),
        });
        this.$router.push({ name: "Re-Step3", params: { code: data[0].id } });
      } else {
        this.$store.dispatch("cleanLocalStorage");
        this.$store.dispatch("setFormatProgramName", {
          ...formatName,
          nivel2: this.getFormatName(name),
        });
        const isOnline = data[0].name.toLowerCase().includes("online");
        const isPdvX = !isOnline && !!(data[0].Locations.length === 1);
        this.$store.dispatch("addSelectedProgramInfo", {
          ...data[0],
          isOnline,
          isPdvX,
        });
        this.$router.push({ name: "ProgramInscription" });
      }
    },
    isThird() {
      let result = false;
      const data = this.$store.state.programData;
      data.forEach((element) => {
        if (element.name.includes("3°")) {
          result = true;
        }
      });
      return result;
    },
    isEsencial(e) {
      if (!e) {
        return false;
      }
      e = e.toLowerCase();
      return e.includes("mentoring") || e.includes("esencial");
    },
  },

  watch: {
    selectedProgramIndex(val) {
      this.$store.dispatch("setSelectedProgramIndex", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.border-ecesnsial {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;

  @media (max-width: 768px) {
    width: 4px;
  }
  @media (min-width: 769px) {
    width: 5px;
  }

  .border1 {
    flex: 1;
    background: #ae4239;
  }
  .border2 {
    flex: 1;
    background: #ffd100;
  }
}

.input-select-program {
  font-size: 16px;
  line-height: 18px;
  border-radius: 100px;
  border: 2px solid #c98d28; /* Color del borde */
  height: 40px;
  width: 180px;
  padding: 0 24px;
  font-family: "ubunturegular", Arial, sans-serif;
  background: transparent;
  appearance: none; /* Oculta la flecha nativa */
  -webkit-appearance: none;
  -moz-appearance: none;
  position: relative;
  cursor: pointer;
}

/* Contenedor para posicionar la flecha */
.select-wrapper {
  position: relative;
  display: inline-block;
  width: 180px;
}

/* Flecha personalizada */
.select-wrapper::after {
  content: "▼"; /* Icono de flecha */
  font-size: 14px;
  color: #c98d28;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none; /* Evita que interfiera con la selección */
}

.boton-new-primario {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: $morado50;
  border: solid 4px $neutralwhite;
  color: $neutralwhite;
  &:hover {
    background-color: $morado30;
  }
  &:active {
    background-color: $morado90;
  }
  &:focus {
    background-color: $morado50;
    border: solid 4px grey;
  }
  &:disabled {
    background-color: #5924661a;
  }

  &.boton-new-largo {
    padding: 0 32px;
    height: 60px;
    width: auto;
    font-size: 20px;
    line-height: 28px;
  }
  &.boton-new-mediano {
    padding: 0 24px;
    height: 48px;
    width: auto;
    font-size: 16px;
    line-height: 18px;
  }
  &.boton-new-pequeno {
    padding: 0 16px;
    height: 32px;
    width: auto;
    font-size: 14px;
    line-height: 22px;
  }

  img {
    margin-right: 16px;
  }
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.par {
  background: #fff0f0;
}

.impar {
  background: #fffaf0;
}
.resaltada {
  background: #cacbce !important;
  &:first-child {
    background: #cacbce !important;
  }

  .main-table-row {
    background: #cacbce !important;
  }
}

.recomendador2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    padding-top: 32px;
  }
  @media (min-width: 769px) {
    padding-top: 40px;
  }
}

.info-recomendador1 {
  @media (max-width: 768px) {
    display: none;
  }

  .fondo {
    background-color: $neutral05;
  }

  .perent-columns {
    display: flex;
    @media (max-width: 768px) {
      flex-direction: column;
      padding: 48px 24px;
    }
    @media (min-width: 769px) {
      flex-direction: row;
      padding: 40px 76px 64px 76px;
      gap: 50px;
    }

    .column-info {
      display: flex;
      flex-direction: column;
      @media (max-width: 768px) {
        width: 100%;
      }
      @media (min-width: 769px) {
        width: 622px;
      }

      .titulo {
        color: $neutralBlack;
        @media (max-width: 768px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 27px;
          line-height: 37px;
          margin-bottom: 32px;
        }
        @media (min-width: 769px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 40px;
          line-height: 50px;
          margin-bottom: 24px;
        }
      }
      .links {
        display: flex;
        flex-direction: column;
        @media (min-width: 769px) {
          margin-bottom: 40px;
        }

        .links-items {
          display: flex;
          justify-content: space-between;
          padding: 16px 0;

          @media (max-width: 768px) {
            width: 100%;
          }
          @media (min-width: 769px) {
            width: 400px;
          }

          .links-items-text {
            img {
              margin-right: 12px;
            }
            span {
              color: $neutralBlack;
              font-family: "Poppins-Medium", sans-serif;
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
      }
      .texto {
        color: $neutralBlack;
        @media (max-width: 768px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 27px;
          line-height: 37px;
          margin-bottom: 32px;
        }
        @media (min-width: 769px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 24px;
        }
      }
      .botones {
        display: flex;
        flex-wrap: wrap;

        @media (max-width: 768px) {
          flex-direction: column;
          gap: 16px;
        }
        @media (min-width: 769px) {
          flex-direction: row;
          gap: 16px;
        }
      }
    }
    .column-ilustracion {
      @media (max-width: 768px) {
        width: 100%;
        margin: 48px 0 36px 0;
      }
      @media (min-width: 769px) {
        flex: 1;
      }
    }
  }
}

.custom-padding {
  @media (max-width: 768px) {
    padding: 0 24px;
  }
  @media (min-width: 769px) {
    padding: 0 76px;
  }
}

.custom-width-column {
  /*width: 33.33%;
    width: 375.95px;*/
  flex-basis: 33.33%;
  flex-shrink: 0;
}

.title-content {
  .title {
    color: $neutralBlack;
    @media (max-width: 768px) {
      font-family: "Poppins-Medium", sans-serif;
      font-size: 18px;
      line-height: 28px;
      margin-bottom: 32px;
    }
    @media (min-width: 769px) {
      font-family: "Poppins-Bold", sans-serif;
      font-size: 32px;
      line-height: 42px;
      margin-bottom: 40px;
    }
  }
}

.wrapper-table {
  overflow: auto;
  white-space: nowrap;
}

.fila {
  display: flex;
}
</style>

<style scoped lang="scss">
.nav-tabs .nav-link.active {
  border: 1px solid transparent !important;
  opacity: 1 !important;
}
.nav-tabs {
  border-bottom: 1px solid transparent !important;
}

.nav-tabs .nav-link {
  height: 56px;
  opacity: 0.5;
  color: #000000 !important;
  background: #ffffff !important;
  border-top-left-radius: 0rem;
  border-top-right-radius: 0;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  /* border-top-left-radius: 0.25rem; */
  /* border-top-right-radius: 0.25rem; */
}

.step-2-content {
  /*padding: 69px 0 18px 0;*/
  @include media-breakpoint-down(md) {
    /*padding: 30px 0 125px;*/
    display: none;
  }

  .error-message-submit {
    position: absolute;
    left: 70%;
    z-index: 10;
    margin-top: 0;
    margin-bottom: 0;
    width: max-content;
    @include media-breakpoint-down(sm) {
      position: static;
      margin: 10px auto;
    }
  }
}

.schedule-list-items-container {
  margin-bottom: 28px;
}

.schedule-select-title {
  display: flex;
  align-items: center;

  p {
    margin-bottom: 0;
    font-size: 18px;
    line-height: 20px;
    @include alternative-regular;
  }

  .program-name {
    span {
      margin-left: 5px;
      color: $blue;
      @include alternative-medium-regular;
      font-size: 18px;
      line-height: 20px;

      &.mention-flat {
        font-size: 14px;
        @include alternative-light-regular;
        padding: 0 5px;
        color: #fff;
        margin-left: 3px;
        line-height: 18px;
      }
    }

    img {
      width: 35px;
    }
  }
}

.schedule-list {
  margin-bottom: 28px;

  span.courses-number {
    font-size: 14px;
    line-height: 16px;
    @include alternative-italic;
    color: $gray-dark;
  }

  .schedule-list-item {
    span {
      font-size: 14px;
      line-height: 16px;
      @include alternative-italic;
      color: $gray-dark;
    }
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 18px;
    @include alternative-regular;
    width: 100%;
    border: 1px solid #979797;
    background: transparent;
    transition: all 0.3s ease;

    &:last-child {
      margin-bottom: 0;
    }

    &.open {
      box-shadow: 0px 4px 10px 1px #0000001c;
    }

    .list-header {
      .btn-pdv-collapse {
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        border: none;

        span {
          font-size: 16px;
          line-height: 18px;
          color: #000;
          @include alternative-medium-regular;
        }

        width: 100%;

        &:not(.collapsed) img {
          transform: rotate(180deg);
        }
        &:focus {
          outline: none;
        }
      }

      &:hover {
        cursor: pointer;
      }
    }

    .schedule-list-content {
      border-top: 1px solid $gray-light;
      padding: 20px 0;

      .custom-radio-cont {
        margin-bottom: 25px;

        &:last-child {
          margin-bottom: 0;
        }

        .radio-label {
          span {
            @include alternative-light-regular;
          }

          .alert-message {
            display: flex;
            align-items: center;

            img {
              width: 20px;
              margin: 0 5px;
            }

            span {
              color: $yellow;
              font-size: 12px;
              @include alternative-medium-regular;
            }
          }
        }
      }
    }
  }
}

.widget-info {
  padding-left: 19px;
  border-left: 1px solid rgba($gray-light, 0.4);

  .widget-title {
    display: flex;
    align-items: center;
    margin-bottom: 19px;

    h4 {
      font-size: 12px;
      letter-spacing: 2px;
      line-height: 22px;
      margin-bottom: 0;
      margin-left: 8px;
      @include alternative-regular;
    }
  }

  .widget-body {
    .widget-body-item {
      margin-bottom: 34px;

      h5 {
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 19px;
        @include alternative-medium-regular;
      }

      .main-info {
        padding-left: 0;
        margin-bottom: 34px;

        li {
          padding-bottom: 20px;
          list-style: none;
          position: relative;

          p {
            line-height: 16px;
            font-size: 14px;
            @include alternative-light-regular;
            position: relative;
            padding-left: 18px;
            color: $gray-dark;
            margin-bottom: 0;

            .hour {
              color: $gray-dark;
              line-height: 16px;
              font-size: 14px;
              @include alternative-light-regular;
            }

            &:before {
              content: "";
              width: 6px;
              height: 6px;
              background: $gray-light;
              border-radius: 50%;
              position: absolute;
              left: 2px;
              top: 50%;
              transform: translateY(-50%);
            }
          }

          &:before {
            content: "";
            width: 1px;
            height: 100%;
            position: absolute;
            background: $gray-light;
            left: 4px;
            top: 10px;
          }

          &:first-child {
            p:before {
              content: "";
              width: 10px;
              height: 10px;
              left: 0;
            }
          }

          &:last-child {
            padding-bottom: 0;

            p:before {
              content: "";
              width: 10px;
              height: 10px;
              left: 0;
            }

            &:before {
              display: none;
            }
          }

          &:first-child {
            .hour:first-child {
              @include alternative-bold;
            }
          }

          &:last-child {
            .hour:last-child {
              @include alternative-bold;
            }
          }
        }
      }
      .main-info.course-list {
        margin-bottom: 15px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.pdv-submit-button {
  .form-group {
    margin-bottom: 0;
  }

  @include media-breakpoint-down(sm) {
    position: fixed;
    width: 100%;
    padding: 23px 16px;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #fff;
  }
}

.box-error-activator {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.pdv-text-uppercase {
  font-family: inherit;
  font-size: inherit;
}

.custom-radio-cont {
  &.disabled {
    cursor: default;
    pointer-events: none;

    .pdv-custom-radio {
      visibility: hidden;
    }

    .radio-label {
      cursor: default;
      span {
        color: $gray;
      }
    }
  }
}

.schedule-list .schedule-list-item .schedule-list-content {
  .custom-radio-cont {
    margin-bottom: 0;
    padding: 15px 20px;
    &:hover {
      background: rgba(255, 237, 192, 0.41);
      .hover-selector-icon {
        display: inline-block;
      }
    }
  }
}

.pdv-form-group .custom-radio-cont .radio-label {
  margin-bottom: 0;
  .pdv-custom-radio {
    background: #fff;
  }
}

.hover-selector-icon {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: none;
  width: 7px;
}

.previous-selected-course-icon {
  filter: grayscale(100%);
  height: 22px;
  position: relative;
  top: -1px;
  opacity: 0.7;
}
.schedule-list-item {
  max-width: 540px;
}

#showDeleteCourseModal {
  position: absolute;
  visibility: hidden;
}
.table-header {
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  /*border-right: 1px solid #979797;
  border-top: 1px solid #979797;
  border-bottom: 1px solid #979797;*/
  // border-bottom: 1px solid #979797;
  &:first-child {
    /*border-bottom: none;
    border-left: 1px solid #979797;*/
    background: #ffffff !important;
    justify-content: flex-start;
    span {
      /*padding-left: 15px;*/
      font-size: 14px !important;
      letter-spacing: 0;
      line-height: 22px !important;
      text-align: left;
      font-family: "Poppins-Bold", sans-serif !important;
    }
  }

  padding: 5px;
  padding-left: 8px;
  &.main-name {
    font-size: 17px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 26px;
    text-align: left;
    /*border-bottom: 1px solid #979797;*/
    span {
      /*padding-left: 15px;*/
      font-size: 17px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 56px;
      text-align: left;
      @include Gotham-Medium;
    }
  }
  .first-line {
    display: flex;
    flex-flow: row;
    .header-name {
      color: #1b1b1d !important;
      display: flex;
      text-align: center;
      align-self: flex-start;
      font-size: 14px !important;
      letter-spacing: 0;
      line-height: 22px !important;
      text-align: center;
      font-family: "Poppins-Bold", sans-serif !important;
    }
    img {
      display: flex;
    }
  }
  .header-sub-name {
    display: flex;
    font-size: 13px;
    line-height: 16px;
    align-self: flex-start;
    @include Gotham;
  }
}
.talk-section {
  margin-bottom: 194px;
  @include media-breakpoint-down(sm) {
    display: none;
  }
}
.quotation-container {
  @include media-breakpoint-down(md) {
    display: none;
  }
  height: 80px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  span {
    line-height: 80px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-self: center;
  }
  .quotation-button {
    background-color: #fff;
    display: flex;
    font-size: 14px;
    padding: 13px 56px 15px 55px;
    @include alternative-medium-regular;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.09px;
    line-height: 20px;
    text-align: center;
    width: 181px;
    border-radius: 4px;
    position: relative;
    z-index: 10;
    @media screen and (max-width: 1024px) {
      width: 100%;
    }
  }
  .quotation-col {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.common-element-header {
  margin-top: 20px;
  background: $yellow;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px 5px 0 0;
  span {
    padding-left: 20px;
    font-weight: 500;
    font-size: 14px;
    color: #000;
    @include Gotham-Light;
  }
}
.table-body {
  .last {
    height: 80px !important;
    background: #ffffff !important;
    /*border: none !important;*/

    &:first-child {
      border: none !important;
    }
  }
  .main-table-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 52px;
    padding-left: 20px;
    background-color: $neutral05;
    /*border-left: 1px solid #979797;
    border-right: 1px solid #979797;*/
    // border-bottom: 1px solid #979797;
    border-bottom: 1px solid $neutral10;
    &:last-child {
      background: #ffffff;
    }
    span {
      font-size: 14px;
      line-height: 22px;
      font-size: 14px !important;
      font-family: "Poppins-Regular", sans-serif !important;
      color: #1b1b1d !important;
    }
  }
  .main-table-value {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    border-bottom: 1px solid $neutral05;
    /*border-right: 1px solid #979797;*/

    span {
      font-size: 14px !important;
      line-height: 22px;
      text-align: center;
      font-family: "Poppins-Regular", sans-serif !important;
      color: #1b1b1d !important;
    }
  }
  .common-element-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    height: 45px;
    border-right: 1px solid #cfcfcf;
    border-bottom: 1px solid #cfcfcf;
    &:first-child {
      border-left: 1px solid #cfcfcf;
    }
    span {
      font-size: 14px;
      line-height: 41px;
      @include Gotham-Light;
      letter-spacing: 0;
      color: #626262;
    }
  }
  .common-element-value {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 45px;
    border-right: 1px solid #cfcfcf;
    border-bottom: 1px solid #cfcfcf;
    span {
      font-size: 14px;
      line-height: 41px;
      text-align: center;
      @include Gotham-Light;
    }
  }
}
.tel-link {
  @include alternative-bold;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 22px;
  letter-spacing: -0.282353px;
  &:before {
    content: url("/images/svgs/telefono.svg");
    width: 18px;
    height: 18px;
    left: 0;
    margin-right: 29px;
  }
}
.call-center-section-text {
  background: #fdf4e1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
}
.call-center-section {
  // margin-top: 25px;
  background: #fdf4e1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 4rem;

  a {
    color: #000;
    &:hover {
      text-decoration: none;
    }
  }
  @media screen and (max-width: 600px) {
    flex-direction: column-reverse;
    padding-top: 40px;
  }
}
.img-text-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.main-mobile-element {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid $neutral05;
  border-left: 1px solid $neutral05;
  border-right: 1px solid $neutral05;

  .main-element-row-container {
    display: flex;
    flex-direction: row;
    background: $neutral05;
    width: 192px;
    max-width: 192px;
    img {
      margin-right: 8px;
    }
  }
  .main-mobile-element-row {
    font-size: 12px;
    line-height: 16px;
    height: 52px;
    color: $neutralBlack;
    font-family: "Poppins-Regular", sans-serif !important;
    padding-left: 8px;
    margin-right: 8px;
  }
  .main-element-row-container-value {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      display: flex;
      align-items: center;
      font-size: 12px;
      line-height: 16px;
      font-family: "Poppins-Regular", sans-serif !important;
    }
  }

  span {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    font-family: "Poppins-Regular", sans-serif !important;
  }
}
.bar {
  height: 32px;
  position: absolute;
  left: 0;
  right: 0;
}
.see-more {
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 61px;
  margin-bottom: 27px;
  @media screen and (max-width: 430px) {
    margin-bottom: 0;
  }
  @include Gotham;
  &:before {
    content: url("/images/iconos/mas-info.png");
    width: 24px;
    height: 24px;
    left: 0;
    margin-right: 10px;
  }
  &.minus {
    &::before {
      content: url("/images/iconos/menos-info.png");
      width: 24px;
      height: 24px;
      left: 0;
      margin-right: 10px;
    }
  }
}
.mobile-first-line {
  display: flex;
  /*margin-top: 15px;*/
  .header-name {
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    margin-right: 5px;
    font-family: "Poppins-Medium", sans-serif !important;
  }
}
.header-sub-name {
  @include media-breakpoint-down(sm) {
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    @include Gotham-Book;
  }
}
.quatation-mobile-button {
  background-color: #000;
  color: #ffd61a;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 40px;
  height: 73px;
  font-weight: 500;
  letter-spacing: 0.09px;
  text-align: center;
  border-radius: 4px;
  @include alternative-medium-regular;
  font-style: normal;
  font-weight: 400;
  font-size: 19px;
  line-height: 21px;
  &:hover {
    background: #ffd61a;
    color: #000000;
  }
}
.price-multiplier {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: $neutral10;
  height: 52px;
  padding: 0 15px;
  font-family: "Poppins-Medium", sans-serif !important;
  .key {
    height: 100%;
    width: 192px;
    display: flex;
    align-items: center;
    padding-left: 8px;

    span {
      color: #000;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 16px;
      font-family: "Poppins-Medium", sans-serif !important;
    }
  }
  .value {
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      color: #000;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 16px;
      font-family: "Poppins-Medium", sans-serif !important;
    }
  }
}
.common-table {
  margin-top: 20px;
  .common-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:nth-child(1) {
      border-top: 1px solid rgba(151, 151, 151, 0.2);
    }
    &:last-child {
      border-bottom: none;
    }
    border-bottom: 1px solid rgba(151, 151, 151, 0.2);
    border-left: none;
    border-right: none;
    .common-container-row {
      display: flex;
      flex-direction: row;
    }
    .common-mobile-row {
      display: flex;
      height: 45px;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 41px;
      color: #626262;
      @include Gotham-Light;
    }
    .common-mobile-value {
      display: flex;
      height: 45px;
      font-size: 14px;
      line-height: 45px;
      @include Gotham-Light;
    }
  }
}
.programs {
  font-size: 25px;
  line-height: 41px;
  font-weight: bold;
  @include Gotham-Book;
}
.questions {
  @include alternative-medium-regular;
  font-style: normal;
  font-weight: 500;
  font-size: 21px;
  line-height: 22px;
  letter-spacing: -0.24px;
  color: #000000;
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1270px;
  }
}
.btn-outlined-step-2 {
  background: #ffd100;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  @include Gotham-Book;
  padding: 6.14px 43px 9.86px 43px;
  width: 172px;
  position: relative;
  border-radius: 2px;
  z-index: 0;
  font-size: 15px;
  letter-spacing: -0.19px;
  line-height: 21px;
  text-align: center;
  margin-top: 12.18px;
  -webkit-appearance: unset;
  @include media-breakpoint-down(sm) {
    width: 50%;
    text-align: center;
  }
}
.choose-program {
  @include Gotham-Medium;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 41px;
}
@media screen and (max-width: 430px) {
  .row {
    width: 100%;
    margin: 0;
  }
}
.main-mobile-element span.main-mobile-element-value {
  @include Gotham-Light;
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  max-width: 154px;
  color: #000;
}
.text-left {
  @include media-breakpoint-down(md) {
    margin-left: 39px !important;
    margin-bottom: 20px !important;
  }
  @include media-breakpoint-down(sm) {
    margin: 0 !important;
  }
}
@include media-breakpoint-down(sm) {
  .no-padding-mobile {
    padding-right: 15px;
    padding-left: 15px;
    margin: 0;
  }
}
@media screen and (max-width: 430px) {
  .no-padding-mobile {
    padding-right: 15px;
    padding-left: 15px;
  }
  .no-padding {
    padding: 0;
  }
}
.black-button {
  width: 169px;
  height: 43px;
  background: #000000;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: "ubuntu_mediumregular", Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: -0.1875px;
  color: #ffd61a;
  &:hover {
    background: #ffd61a;
    color: #000000;
  }
}
.form-control {
  font-size: 16px;
  line-height: 18px;
  border-radius: 100px;
  border: 2px solid $neutral30;
  height: 52.38px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  font-family: "ubunturegular", Arial, sans-serif;
  background: transparent !important;
}
.form-control-2 {
  font-size: 16px;
  line-height: 18px;
  border-radius: 100px;
  border: 2px solid $neutral30;
  height: 52.38px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  font-family: "ubunturegular", Arial, sans-serif;
  background: transparent !important;
}

.title-commons {
  color: $neutralBlack;
  font-family: "Poppins-Bold", sans-serif;
  @media (max-width: 768px) {
    font-size: 22px;
    line-height: 32px;
  }
  @media (min-width: 769px) {
    font-size: 40px;
    line-height: 50px;
  }
}
.list-commons {
  display: flex;
}
.item-commons {
  span {
    font-family: "Poppins-Regular", sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: $neutralBlack;
  }
}

.tabbable .nav-tabs {
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
  height: 56px;
}
.tabbable .nav-tabs .nav-link {
  width: 45vw;
  min-width: 45vw;
  display: flex;
}

.tab-content {
  padding-top: 16px;
}
</style>
<style lang="scss">
.tooltip {
  display: block !important;
  z-index: 10000;
  &.value {
    .tooltip-inner {
      background: black;
      color: white;
      font-size: 13px;
      line-height: 18px;
      letter-spacing: 0;
      @include Gotham-Light;
      border-radius: 4px !important;
      padding: 13px 21px 13px 20px;
    }
  }
}
.ipad-pro {
  @media screen and (max-width: 1024px) {
    padding: 0;
  }
}
.header-title {
  @media screen and (max-width: 430px) {
    margin-top: 32px !important;
  }
}
.price-container {
  @media screen and (max-width: 430px) {
    position: absolute;
    border-left: 1px solid $neutral10;
    border-right: 1px solid $neutral10;
  }
}
.button-see-more {
  padding: 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 1px $neutral10;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;

  @media screen and (max-width: 430px) {
    margin-top: 52px !important;
  }
}

.flex-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
